/**
 * dreifive – Dual GTM + CookieFirst + Consent Mode v2
 * Asset: d5-gtm-consent-dual.js
 * Version: 2026-04-01
 *
 * PARALLELBETRIEB: Alter GTM (GTM-W26WHKV) + Neuer GTM (GTM-WZHMH3KL)
 *
 * Dieses Script übernimmt:
 * 1. Google Consent Mode v2 Defaults (für den neuen GTM)
 * 2. CookieFirst Banner laden (je nach Domain/API-Key)
 * 3. Alter GTM laden (GTM-W26WHKV) – Basic Mode, identisch zum bisherigen Setup
 * 4. Neuer GTM laden (GTM-WZHMH3KL) – Basic Mode, via t.vetsak.com
 * 5. Shopify Customer Privacy API Sync (sh-customer-privacy.js)
 * 6. Bei Consent-Änderung:
 *    - Alter GTM: cf_after_consent_update Event (wie bisher)
 *    - Neuer GTM: gtag consent update + d5_consent_update Event
 *
 * Einbindung im theme.liquid:
 *   <script src="{{ 'd5-gtm-consent-dual.js' | asset_url }}"></script>
 *
 * WICHTIG: Den gesamten bestehenden Script-Block (CookieFirst + GTM + sh-customer-privacy)
 *          im theme.liquid durch die obige Zeile ersetzen.
 *
 * Nach erfolgreichem Testing des neuen GTM:
 *   - Alten GTM (W26WHKV) und cf_after_consent_update entfernen
 *   - Auf d5-gtm-consent.js (nur neuer GTM) umstellen
 */

(function () {
  "use strict";

  // ===========================================================================
  // Config
  // ===========================================================================
  var OLD_GTM_ID = "GTM-W26WHKV";       // Bestehender Live-Container
  var NEW_GTM_ID = "GTM-WZHMH3KL";      // Neuer Consent Mode v2 Container
  var NEW_GTM_DOMAIN = "https://t.vetsak.com";
  var DEBUG = false;

  // CookieFirst API Keys pro Domain
  // Domains ohne Eintrag (z.B. us.vetsak.com) laufen ohne CookieFirst
  var CF_API_KEYS = {
    "za.vetsak.com":                "38ba30eb-8905-4a7b-adc4-5ca4c59133bd",
    "it.vetsak.com":                "a6955b1b-9fe2-4bbb-8811-5a784127a0dc",
    "nl.vetsak.com":                "a98fdf2e-06c6-4d57-8b0f-c01f9f55e089",
    "fr.vetsak.com":                "f424e3a3-7259-4f1b-bcb1-b96d9ebbe394",
    "de.vetsak.com":                "aa411495-9943-4428-a015-8865019e7b4e",
    "vetsak-test.myshopify.com":    "aa411495-9943-4428-a015-8865019e7b4e",
    "vetsak-staging.myshopify.com": "aa411495-9943-4428-a015-8865019e7b4e",
    "vetsak.com":                   "9d13ea62-2744-4551-ace4-88c0a3cfb77a"
  };

  // EU/EEA + CH + GB Region Codes für Consent Mode v2 Defaults
  var EU_REGIONS = [
    "AT","BE","BG","HR","CY","CZ","DK","EE","FI",
    "FR","DE","GR","HU","IE","IT","LV","LT","LU",
    "MT","NL","PL","PT","RO","SK","SI","ES","SE",
    "GB","IS","LI","NO","CH"
  ];

  // ===========================================================================
  // Helpers
  // ===========================================================================
  var hostname = window.location.hostname;
  var apiKey = CF_API_KEYS[hostname] || null;

  window.dataLayer = window.dataLayer || [];
  function gtag() { window.dataLayer.push(arguments); }

  function log() {
    if (DEBUG) console.log.apply(console, ["d5-consent-dual:"].concat(Array.prototype.slice.call(arguments)));
  }

  // ===========================================================================
  // 1. Consent Mode v2 Defaults (für neuen GTM)
  //    Muss VOR beiden GTM-Loads im dataLayer stehen
  // ===========================================================================

  // EU/EEA/CH/GB: alles denied
  gtag("consent", "default", {
    ad_storage:              "denied",
    ad_user_data:            "denied",
    ad_personalization:      "denied",
    analytics_storage:       "denied",
    functionality_storage:   "denied",
    personalization_storage: "denied",
    security_storage:        "granted",
    wait_for_update:         500,
    regions:                 EU_REGIONS
  });

  // Rest der Welt: alles granted
  gtag("consent", "default", {
    ad_storage:              "granted",
    ad_user_data:            "granted",
    ad_personalization:      "granted",
    analytics_storage:       "granted",
    functionality_storage:   "granted",
    personalization_storage: "granted",
    security_storage:        "granted"
  });

  log("consent defaults set", apiKey ? "(CookieFirst domain)" : "(no CookieFirst)");

  // ===========================================================================
  // 2. Consent Update Handlers
  // ===========================================================================

  /**
   * NEUER GTM: Consent Mode v2 Update + d5_consent_update Event
   */
  function pushConsentUpdate(analyticsGranted, marketingGranted, functionalGranted) {
    var update = {};

    if (analyticsGranted) {
      update.analytics_storage = "granted";
    }
    if (marketingGranted) {
      update.ad_storage         = "granted";
      update.ad_user_data       = "granted";
      update.ad_personalization = "granted";
    }
    if (functionalGranted) {
      update.functionality_storage  = "granted";
      update.personalization_storage = "granted";
    }

    if (Object.keys(update).length > 0) {
      gtag("consent", "update", update);
    }

    // Einheitliches d5 Event (identisch zum Sandbox-Pixel)
    window.dataLayer.push({
      event:                 "d5_consent_update",
      d5_consent_analytics:  !!analyticsGranted,
      d5_consent_marketing:  !!marketingGranted,
      d5_consent_functional: !!functionalGranted
    });

    log("new GTM consent updated:", {
      analytics: analyticsGranted,
      marketing: marketingGranted,
      functional: functionalGranted,
      gtagUpdate: update
    });
  }

  /**
   * ALTER GTM: cf_after_consent_update Event (wie bisher)
   */
  function pushLegacyConsentEvent(necessary, functional, performance, advertising) {
    window.dataLayer.push({
      event: "cf_after_consent_update",
      cf_necessary_enabled:   !!necessary,
      cf_functional_enabled:  !!functional,
      cf_performance_enabled: !!performance,
      cf_advertising_enabled: !!advertising
    });

    log("old GTM consent event pushed (cf_after_consent_update)");
  }

  // ===========================================================================
  // 3. CookieFirst Banner laden (wenn API Key vorhanden)
  // ===========================================================================
  if (apiKey) {
    var cfScript = document.createElement("script");
    cfScript.src = "https://consent.cookiefirst.com/sites/" + hostname + "-" + apiKey + "/consent.js";
    document.head.appendChild(cfScript);
    log("CookieFirst banner loading for", hostname);

    // Shopify Customer Privacy API Sync
    var shScript = document.createElement("script");
    shScript.src = "https://consent.cookiefirst.com/sh-customer-privacy.js";
    shScript.defer = true;
    document.head.appendChild(shScript);
  }

  // ===========================================================================
  // 4. ALTER GTM laden (GTM-W26WHKV) – via t.vetsak.com, wie bisher
  // ===========================================================================
  var oldGtmScript = document.createElement("script");
  oldGtmScript.text =
    "(function(w,d,s,l,i){" +
      "w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});" +
      "var f=d.getElementsByTagName(s)[0]," +
      "j=d.createElement(s)," +
      "dl=l!='dataLayer'?'&l='+l:'';" +
      "j.async=true;" +
      "j.src='https://t.vetsak.com/gtm.js?id='+i+dl;" +
      "f.parentNode.insertBefore(j,f);" +
    "})(window,document,'script','dataLayer','" + OLD_GTM_ID + "')";

  if (apiKey) {
    // BASIC MODE: CookieFirst blockiert bis Consent
    oldGtmScript.setAttribute("data-cookiefirst-category", "functional");
    oldGtmScript.type = "text/plain";
    log("old GTM blocked until CookieFirst consent");
  } else {
    // Kein CookieFirst (z.B. us.vetsak.com): sofort laden + Legacy Event
    oldGtmScript.type = "text/javascript";
    pushLegacyConsentEvent(true, true, true, true);
    log("old GTM loading immediately (no CookieFirst)");
  }

  document.head.appendChild(oldGtmScript);

  // ===========================================================================
  // 5. NEUER GTM laden (GTM-WZHMH3KL) – via t.vetsak.com
  // ===========================================================================
  var newGtmScript = document.createElement("script");
  newGtmScript.text =
    "(function(w,d,s,l,i){" +
      "w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});" +
      "var f=d.getElementsByTagName(s)[0]," +
      "j=d.createElement(s)," +
      "dl=l!='dataLayer'?'&l='+l:'';" +
      "j.async=true;" +
      "j.src='" + NEW_GTM_DOMAIN + "/gtm.js?id='+i+dl;" +
      "f.parentNode.insertBefore(j,f);" +
    "})(window,document,'script','dataLayer','" + NEW_GTM_ID + "')";

  if (apiKey) {
    // BASIC MODE: CookieFirst blockiert bis Consent
    newGtmScript.setAttribute("data-cookiefirst-category", "functional");
    newGtmScript.type = "text/plain";
    log("new GTM blocked until CookieFirst consent");
  } else {
    // Kein CookieFirst: sofort laden + Full Consent
    newGtmScript.type = "text/javascript";
    pushConsentUpdate(true, true, true);
    log("new GTM loading immediately (no CookieFirst)");
  }

  document.head.appendChild(newGtmScript);

  // ===========================================================================
  // 6. CookieFirst Consent Callbacks
  // ===========================================================================
  if (apiKey) {

    // ----- Methode A: cf_consent Window Event (direkt von CookieFirst) -----
    window.addEventListener("cf_consent", function (event) {
      var consent = event.detail || {};

      // Neuer GTM: Consent Mode v2
      pushConsentUpdate(
        consent.performance,
        consent.advertising,
        consent.functional
      );

      // Alter GTM: Legacy Event
      pushLegacyConsentEvent(
        true,                  // necessary ist immer true
        consent.functional,
        consent.performance,
        consent.advertising
      );
    });

    // ----- Methode B: Polling-Fallback für Returning Visitors -----
    // Falls der User bereits Consent gegeben hat und CookieFirst
    // keinen neuen cf_consent Event feuert
    var checkExisting = setInterval(function () {
      if (typeof window.CookieFirst === "undefined") return;
      clearInterval(checkExisting);

      var consent = window.CookieFirst.consent || {};
      if (consent.performance || consent.advertising || consent.functional) {
        // Neuer GTM: Consent Mode v2
        pushConsentUpdate(
          consent.performance,
          consent.advertising,
          consent.functional
        );

        // Alter GTM: Legacy Event
        pushLegacyConsentEvent(
          true,
          consent.functional,
          consent.performance,
          consent.advertising
        );

        log("existing consent detected on load:", consent);
      }
    }, 200);

    // Safety: Stop polling nach 5 Sekunden
    setTimeout(function () { clearInterval(checkExisting); }, 5000);
  }

  log("d5-gtm-consent-dual.js loaded", {
    hostname: hostname,
    hasCookieFirst: !!apiKey,
    oldGTM: OLD_GTM_ID,
    newGTM: NEW_GTM_ID
  });
})();

/* d5 fix v3 05.10.2026: CookieFirst-Consent an Shopify Customer Privacy API melden (Zustimmung UND Widerruf). Shopify-Pixel (u.a. GTM im Sandbox, Checkout) lesen nur den Shopify-Consent; sh-customer-privacy.js verpasst ihn wegen Ladereihenfolge. Wartet per Polling auf die API, gleicht beim Laden und bei jeder Aenderung ab, nur wenn Shopify abweicht. Additiv, idempotent. ACHTUNG: bei jedem Theme-Release mit uebernehmen. */ (function(){ var tries=0, requested=false, pending=""; function cf(){ var c=window.CookieFirst; return (c&&c.consent)?c.consent:null; } function api(){ var s=window.Shopify; return (s&&s.customerPrivacy&&typeof s.customerPrivacy.setTrackingConsent==="function")?s.customerPrivacy:null; } function sync(){ var c=cf(), a=api(); if(!c||!a) return false; var t={analytics:!!c.performance,marketing:!!c.advertising,preferences:!!c.functional,sale_of_data:!!c.advertising}; var pref=(typeof a.preferencesProcessingAllowed==="function")?a.preferencesProcessingAllowed():t.preferences; if(a.analyticsProcessingAllowed()===t.analytics && a.marketingAllowed()===t.marketing && pref===t.preferences) return true; var key=JSON.stringify(t); if(key===pending) return true; pending=key; try{ a.setTrackingConsent(t,function(){ pending=""; }); }catch(e){ pending=""; } return true; } function request(){ if(requested||api()) return; requested=true; try{ if(window.Shopify&&typeof window.Shopify.loadFeatures==="function") window.Shopify.loadFeatures([{name:"consent-tracking-api",version:"0.1"}],function(){ sync(); }); }catch(e){} } window.addEventListener("cf_consent",function(){ sync(); }); window.addEventListener("cf_consent_loaded",function(){ sync(); }); var iv=setInterval(function(){ tries++; if(tries===4) request(); if(sync() || tries>60) clearInterval(iv); },500); })();